import apiClient from "../utils/apiClient";


// reusable error handler
const handleApiError = (error, defaultMessage) => {
  console.error(defaultMessage, error);

  throw {
    status: error.response?.status,
    message:
      error.response?.data?.message ||
      error.response?.data?.detail ||
      defaultMessage,
    data: error.response?.data || null,
  };
};



// GET tree species list
export const getTreeSpeciesApi = async (filters = {}, page = 1, pageSize = 12) => {
  try {
    const params = {
      ...filters,
      page,
      page_size: pageSize,
    };

    const response = await apiClient.get("/species/tree-species/", {
      params,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
    });

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to fetch tree species.");
  }
};


// CREATE tree species
export const createTreeSpeciesApi = async (formData) => {
  try {
    const response = await apiClient.post(
      "/species/tree-species/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to create tree species.");
  }
};



// UPDATE tree species
export const updateTreeSpeciesApi = async (id, formData) => {
  try {
    const response = await apiClient.patch(
      `/species/tree-species/${id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to update tree species.");
  }
};



// DELETE tree species
export const deleteTreeSpeciesApi = async (id) => {
  try {
    const response = await apiClient.delete(
      `/species/tree-species/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to delete tree species.");
  }
};


// ────────────────────────────────────────────────
// Add this function to your existing treeSpeciesApi file
// ────────────────────────────────────────────────

// apis/treeSpeciesApi.js
export const getTreeSpeciesDetailApi = async (id) => {
  try {
    const response = await apiClient.get(`/species/tree-species/${id}/`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
    });
    // Return the inner data directly for consistency with list endpoint
    return response.data.data || response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch tree species detail.");
  }
};